import React from 'react';
import { LockIcon } from 'lucide-react';
import { PaymentLogos } from './PaymentLogos';

/**
 * Compact secure-checkout reassurance used inside every pack card: the lock
 * message plus the accepted card and wallet marks.
 */
export function SecureCheckoutNote({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`border-t border-white/10 pt-4 ${className}`} data-id="element-1305" data-mp="39gsz8ttsqlb7">
      <p className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.16em] text-offwhite" data-id="element-1306" data-mp="3dhmnjob5i24m">
        <LockIcon className="h-3.5 w-3.5 shrink-0 text-grit-500" aria-hidden="true" data-id="element-1307" data-mp="3ifxwlwtmg8ls" />
        Secure checkout · 256-bit SSL
      </p>
      <p className="mt-1.5 text-[12px] leading-relaxed text-steel-400" data-id="element-1308" data-mp="3n7oeqoysw0nr">
        Pay with any major card, PayPal, Venmo, Amazon Pay, Apple Pay, Google Pay or Shop Pay. Payment details are
        encrypted end to end. We never see or store your card number.
      </p>
      <div className="mt-3" data-id="element-1309" data-mp="511ksp94459y">
        <PaymentLogos data-id="element-1310" data-mp="523055x5vdxh" />
      </div>
    </div>;
}